import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-create',
		path: '/admin/comms/send_orders/create',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-comms-ordersV2-create" */ './index'), {
			exportName: 'AdminCommsOrdersCreate',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
